
import { Component, Mixins } from 'vue-property-decorator';
import QrcodeVue from 'qrcode.vue';
import { Auth } from 'aws-amplify';
import MessageToastMixin from '@/mixins/MessageToastMixin';

@Component({
  components: {
    QrcodeVue,
  },
})
export default class OnboardingAuthenticator extends Mixins(MessageToastMixin) {
  code = '';

  token = '';

  created() {
    this.setupToken();
  }

  async setupToken() {
    await Auth.setupTOTP(this.user)
      .then((data: string) => {
        const { username } = this;
        const issuer = 'Lamb Weston / Meijer';

        this.token = `otpauth://totp/${username}?secret=${data}&issuer=${issuer}`;
      })
      .catch((e: Error) => this.showError(e.message));
  }

  async checkCode() {
    await Auth.verifyTotpToken(this.user, this.code)
      .then(() => {
        this.setMFA();
      })
      .catch((e: Error) => this.showError(e.message));
  }

  async setMFA() {
    await Auth.setPreferredMFA(this.user, 'TOTP')
      .then(() => {
        this.$emit('finished');
      })
      .catch((e: Error) => this.showError(e.message));
  }

  get user() {
    return this.$store.state.auth.user;
  }

  get username() {
    if (this.user && this.user.attributes && this.user.attributes.email) {
      return this.user.attributes.email;
    }

    return this.user.username;
  }
}
